/**
 * 住所検索 by zipcloud （http://zipcloud.ibsnet.co.jp/doc/api)
 *
 * @param postalCode 郵便番号（7桁の数字。ハイフン付きでも可。完全一致検索）
 * @returns 都道府県、住所
 */
export async function searchByPostalCode(postalCode) {
    const url = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + postalCode;
    const response = await fetch(url);
    const data = await response.json();
    const results = data.results;
    const address1 = results[0].address1;
    const address2 = results[0].address2;
    const address3 = results[0].address3;
    return {
        prefecture: address1,
        address: address2 + address3,
    };
}
export async function searchByPostalCodeForRegistrationAndSignup(postalCode) {
    const url = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + postalCode;
    const response = await fetch(url);
    const data = await response.json();
    const results = data.results;
    if (data.status === 200 && (results === null || results.length <= 0)) {
        throw new Error('住所が見つかりませんでした。');
    }
    if (data.status === 200 && results !== null && results.length > 0) {
        const address1 = results[0].address1;
        const address2 = results[0].address2;
        const address3 = results[0].address3;
        return {
            prefecture: address1,
            address: address2 + address3,
        };
    }
    return null;
}
